module.exports = __webpack_public_path__ + "img/法半夏.c7862675.jpg";